import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from "react";
import { useIntl } from "react-intl";
import Icon from "@Components/Icon";
import checkboxClasses from "../../overrides/venia-ui/components/Checkbox/checkbox.module.scss";
import classes from "./privacyComponents.module.scss";
var nextInstanceId = 0;
export var MarketingConsentChoices = _ref => {
  var {
    consents,
    onChange,
    idPrefix,
    disabled = false
  } = _ref;
  var {
    formatMessage
  } = useIntl();
  // The page and registration drawer can both be mounted at the same time.
  var [instanceId] = useState(() => ++nextInstanceId);
  return /*#__PURE__*/React.createElement("fieldset", {
    className: classes.choices,
    disabled: disabled
  }, /*#__PURE__*/React.createElement("legend", null, formatMessage({
    id: "consents.capture.optional"
  })), ["communication", "profiling"].map(purpose => {
    var id = "".concat(idPrefix, "-").concat(instanceId, "-").concat(purpose);
    var checked = consents[purpose] === true;
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(checkboxClasses.area, " ").concat(classes.choice),
      key: purpose
    }, /*#__PURE__*/React.createElement("label", {
      className: checkboxClasses.root,
      htmlFor: id
    }, /*#__PURE__*/React.createElement("input", {
      id: id,
      name: purpose,
      type: "checkbox",
      checked: checked,
      "aria-label": formatMessage({
        id: "consents.capture.".concat(purpose)
      }),
      className: checked ? checkboxClasses.inputChecked : checkboxClasses.input,
      "aria-describedby": "".concat(id, "-description"),
      onChange: event => onChange(_objectSpread(_objectSpread({}, consents), {}, {
        [purpose]: event.target.checked
      }))
    }), /*#__PURE__*/React.createElement("span", {
      className: checkboxClasses.icon,
      "aria-hidden": "true"
    }, checked ? /*#__PURE__*/React.createElement(Icon, {
      name: "icon-check",
      color: "white"
    }) : null), /*#__PURE__*/React.createElement("span", null, formatMessage({
      id: "consents.capture.".concat(purpose)
    }), /*#__PURE__*/React.createElement("span", {
      id: "".concat(id, "-description"),
      className: classes.description
    }, formatMessage({
      id: "consents.page.".concat(purpose, ".description")
    })))));
  }));
};